import { Box, Button, Tooltip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { ContactViewContext } from "contexts/ContactView";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { OutreachContact } from "schemas/dashboard";

interface IProps {
  outreachContact: OutreachContact;
}

const styles = {
  root: {
    mx: 1,
    my: 0.5,
    display: "flex",
    justifyContent: "center",
  },
  smallButton: {
    textTransform: "none",
    textDecoration: "underline",
    fontSize: 12,
    whiteSpace: "nowrap",
    height: 25,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  text: {
    mx: 1,
    color: grey[400],
    fontSize: 11,
  },
};

export default function TableTemplateUsed({ outreachContact }: IProps) {
  const { outreachTemplates } = useContext(OutreachTemplatesContext);
  const { trackTable } = useContext(ContactViewContext);
  const navigate = useNavigate();

  if (!outreachContact.latestOutreachTemplateId) {
    return (
      <Box>
        <Tooltip title="Only emails sent after November 1 will track template used">
          <Typography textAlign="center" sx={styles.text}>
            No data available
          </Typography>
        </Tooltip>
      </Box>
    );
  }

  const outreachTemplate = outreachTemplates.find(
    (t) => t.id === outreachContact.latestOutreachTemplateId,
  );

  if (!outreachTemplate) {
    return (
      <Box>
        <Tooltip title="The original template has been deleted">
          <Typography textAlign="center" sx={styles.text}>
            No data available
          </Typography>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box sx={styles.root}>
      <Button
        disableElevation
        tabIndex={-1}
        variant="text"
        color="inherit"
        sx={styles.smallButton}
        onClick={() => {
          trackTable("Tracking Table Template Button Pressed", {
            templateId: outreachTemplate.id,
            templateName: outreachTemplate.name,
            "Outreach Contact ID": outreachContact?.id,
            "Outreach Contact Email": outreachContact?.email,
          });
          navigate(`templates/${outreachTemplate.id}`);
        }}
      >
        {outreachTemplate.name}
      </Button>
    </Box>
  );
}
